export const KNOWN_WORDS = 1;
export const UNKNOWN_WORDS = 2;
export const SHUFFLED_WORDS = 3;
export const ALL_WORDS = 4;
export const MASTERED_WORDS = 5;